export const SET_EDIT_ROLE_USERS_LOADED = "SET_EDIT_ROLE_USERS_LOADED";

export const setEditRoleUsersLoaded = (editRoleUsersLoaded: boolean) => {
  return {
    editRoleUsersLoaded,
    type: SET_EDIT_ROLE_USERS_LOADED
  };
};
